export default {"src":"/_next/static/media/bar-icon.eef85291.svg","height":18,"width":36,"blurWidth":0,"blurHeight":0};